import React from 'react';
import { FlameIcon, TriangleAlertIcon } from 'lucide-react';
import { CampaignGantt } from '../components/CampaignGantt';
import { ChannelLoad } from '../components/ChannelLoad';
import { DeliveryStatus } from '../components/DeliveryStatus';
import { PageHeader } from '../components/PageHeader';
import { Panel } from '../components/Panel';
import { PillarSplit } from '../components/PillarSplit';
import { StatTile } from '../components/StatTile';
import { allSlots } from '../data/calendar';
import { campaigns, collisionNote, heavyDays, planMeta, riskNote } from '../data/plan';
import { blockedSlots } from '../utils/stats';
export function Overview() {
  const blocked = blockedSlots(allSlots).length;
  return <div data-id="element-206" data-mp="2qi2s7ce3x7q1">
      <PageHeader eyebrow={`${planMeta.window} · eight weeks`} title="One plan, two months, six campaigns" description="August and September run as one continuous plan so the campaigns that straddle the month boundary get proper build-up arcs instead of restarting on Sep 1." data-id="element-207" data-mp="2qgje9sfxb8rf" />

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4" data-id="element-208" data-mp="2zecgbwgdanss">
        <StatTile index={0} label="Planned slots" value={planMeta.total} sub="Anchors plus the always-on slate, counted not assumed" accent="rgb(var(--chalk))" data-id="element-209" data-mp="2uljf3ik3xxlg" />
        <StatTile index={1} label="Anchor slots" value={planMeta.anchors} sub="Briefed, produced, date-specific content" accent="rgb(var(--campaign))" data-id="element-210" data-mp="2qi3hok07rt7p" />
        <StatTile index={2} label="Always-on slate" value={planMeta.slate} sub="Recurring evergreen and product slots underneath" accent="rgb(var(--evergreen))" data-id="element-211" data-mp="3iam4jckzguqi" />
        <StatTile index={3} label="Campaigns" value={campaigns.length} sub={`${blocked} slots blocked on a decision`} accent="rgb(var(--productc))" data-id="element-212" data-mp="39az34qs97oxg" />
      </div>

      <div className="mt-4 grid gap-4 xl:grid-cols-3" data-id="element-213" data-mp="34bmfi3tk6dtt">
        <Panel eyebrow="Hero periods" title="Campaigns across the window" className="xl:col-span-2" data-id="element-214" data-mp="1xwbrm4zxheew">
          <CampaignGantt data-id="element-215" data-mp="1swfvst1dwtaf" />
          <div className="mt-4 flex gap-3 rounded-xl border border-campaign/25 bg-campaign/5 px-4 py-3" data-id="element-216" data-mp="1sv4gpx2hnz40">
            <TriangleAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-campaign" aria-hidden="true" data-id="element-217" data-mp="1uee7uhaaq0y1" />
            <div data-id="element-218" data-mp="1zc6bg8kazbi2">
              <p className="text-[13px] font-medium text-chalk" data-id="element-219" data-mp="1zalgihu2tqjo">Collision handling</p>
              <p className="mt-1 text-xs leading-relaxed text-mute" data-id="element-220" data-mp="1lcwx7efnqrgq">{collisionNote}</p>
            </div>
          </div>
        </Panel>

        <div className="space-y-4" data-id="element-221" data-mp="1bnn3ju5610qi">
          <Panel eyebrow="Ticked off by the team" title="Delivery status" data-id="element-222" data-mp="1bmleglrbedps">
            <DeliveryStatus data-id="element-223" data-mp="1gemw6n794wn7" />
          </Panel>

          <Panel eyebrow="Counted, not estimated" title="Pillar split" data-id="element-224" data-mp="1gfekre2flu3z">
            <PillarSplit data-id="element-225" data-mp="12nzzt1oyriua" />
          </Panel>

          <Panel eyebrow="Staff the replies" title="Heaviest days" data-id="element-226" data-mp="12kvolkd2zmu4">
            <ul className="space-y-2.5" data-id="element-227" data-mp="16otldoexolk0">
              {heavyDays.map(d => <li key={d.date} className="flex items-center gap-3 rounded-lg border border-ink-700 bg-ink-800/50 px-3 py-2" data-id="element-228" data-mp="sptzgoit2krj">
                  <FlameIcon className="h-4 w-4 shrink-0 text-campaign" aria-hidden="true" data-id="element-229" data-mp="xmu9fais07nx" />
                  <span className="font-mono text-[11px] text-chalk" data-id="element-230" data-mp="e22dcqy9krb1">{d.date}</span>
                  <span className="truncate text-xs text-mute" data-id="element-231" data-mp="940qrw1mq9ut">{d.reason}</span>
                </li>)}
            </ul>
          </Panel>
        </div>
      </div>

      <div className="mt-4 grid gap-4 xl:grid-cols-3" data-id="element-232" data-mp="j0ncen1s54xw">
        <Panel eyebrow="The one real risk" title="Campaign layer vs. everything else" className="xl:col-span-2" data-id="element-233" data-mp="j39kcnsl1mgn">
          <p className="text-sm leading-relaxed text-mute" data-id="element-234" data-mp="s1l6acii7w2r">{riskNote}</p>
          <p className="mt-4 border-l-2 border-campaign pl-4 font-display text-xl leading-snug text-chalk" data-id="element-235" data-mp="s1bimvkxm108">
            Campaign at ~20% is defensible for a window this dense — treat it as a ceiling, not a new normal. October
            should come back to 15–18%.
          </p>
        </Panel>

        <Panel eyebrow="Anchor slots by network" title="Where the weight lands" data-id="element-236" data-mp="1frficrv01gly">
          <ChannelLoad data-id="element-237" data-mp="1bqvpi0hgkz5m" />
        </Panel>
      </div>
    </div>;
}